export enum AdminWebRoute {
  EventsOverview = 'events-overview',
  CreateEvent = 'create-event',
  CreateEventAddVisibility = 'add-visibility',
  CreateEventAddEditQuestions = 'add-edit-questions',
  CreateEventAddEditEvaluationQuestions = 'add-edit-evaluation-questions',
  Dashboard = 'dashboard',
  EmployeesOverview = 'employees-overview',
  EventDetails = 'event-details',
  InterestAnalytics = 'interest-analytics',
  EventAnalytics = 'event-analytics',
  Settings = 'settings',
  SettingsGeneral = 'general',
  SettingsIntegrations = 'integrations',
  SettingsAdminManagement = 'admin-management',
}
